module.exports = __webpack_public_path__ + "static/media/DevelopmentInLab.d4c0e8ab.JPG";